import React, { useState, useCallback, useContext, useMemo } from 'react';
import { Header, HeaderContextParams, HeaderContextProviderParams } from './';
import PaymentSettingsModal from './PaymentSettingsModal';

const noop = (_: string): void => {};
const noopVoid = (): void => {};

const HeaderContext = React.createContext<HeaderContextParams>({
    setHeaderTitle: noop,
    setHeaderSubTitle: noop,
    isPaymentSettingsOpen: false,
    openPaymentSettings: noopVoid,
    closePaymentSettings: noopVoid,
});
const HeaderContextProvider = ({ children }: HeaderContextProviderParams) => {
    const [title, setTitle] = useState<string>('');
    const [subTitle, setSubTitle] = useState<string>('')
    const [isPaymentSettingsOpen, setIsPaymentSettingsOpen] = useState<boolean>(false);

    const setHeaderTitle = useCallback((headerTitle: string) => {
        setTitle(headerTitle);
    }, []);
    const setHeaderSubTitle = useCallback((headerSubTitle : string) => {
        setSubTitle(headerSubTitle);
    }, []);
    const openPaymentSettings = useCallback(() => {
        setIsPaymentSettingsOpen(true);
    }, []);
    const closePaymentSettings = useCallback(() => {
        setIsPaymentSettingsOpen(false);
    }, []);

    const value: HeaderContextParams = useMemo(() => (
            {
                setHeaderTitle,
                setHeaderSubTitle,
                isPaymentSettingsOpen,
                openPaymentSettings,
                closePaymentSettings,
            }),
        [
            setHeaderTitle,
            setHeaderSubTitle,
            isPaymentSettingsOpen,
            openPaymentSettings,
            closePaymentSettings,
        ]);
    return (
        <HeaderContext.Provider value={value}>
            <Header title={title} subTitle={subTitle}/>
            {children}
            <PaymentSettingsModal/>
        </HeaderContext.Provider>
    )
};

const useHeader = () => useContext(HeaderContext);

export { useHeader, HeaderContextProvider };